// Redirecionamento imediato para o novo painel
window.location.replace("https://painel.treino.io");
